// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Form-form-number-StMwP {\n  height: 18px;\n  width: 18px;\n}\n", "",{"version":3,"sources":["webpack://./src/globals/Form.less"],"names":[],"mappings":"AACA;EACI,YAAA;EACA,WAAA;AAAJ","sourcesContent":["@environment_type_id: 1;\n.form-number {\n    height: 18px;\n    width: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form-number": "Form-form-number-StMwP"
};
export default ___CSS_LOADER_EXPORT___;
